import { AlertTriangle, CheckCircle2, Users } from "lucide-react";

const COLS = [
  ["queue", "Queue"], ["entries", "Calls"], ["files", "Traces"],
  ["avg_wait", "Avg wait"], ["max_wait", "Max wait"],
  ["answered", "Answered"], ["no_agent_answer", "No answer"],
  ["timeout", "Timeout"], ["abandoned", "Abandoned"],
];

const secs = (v) => (v === null || v === undefined ? "—" : `${v}s`);

export const QueueInsight = ({ insight }) => {
  const queues = insight?.queues || [];
  if (!queues.length) return null;
  const clean = (insight.unanswered || 0) === 0;
  return (
    <div className="space-y-3 rounded-lg border border-slate-200 p-4" data-testid="sip-queue-insight">
      <div className="flex items-center gap-2">
        <Users className="h-4 w-4 text-slate-400" />
        <h3 className="text-sm font-semibold text-slate-800">Queue insight</h3>
        <span className="text-[11px] text-slate-400">
          {insight.total_entries} queue entr{insight.total_entries === 1 ? "y" : "ies"} across {insight.files_covered} trace(s)
        </span>
      </div>
      <ul className="space-y-1" data-testid="sip-queue-headlines">
        {(insight.headlines || []).map((h, i) => (
          <li key={i} className={`flex items-start gap-2 text-sm ${clean ? "text-emerald-700" : "text-slate-600"}`}>
            {clean ? <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-600" />
                   : <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-500" />}
            <span>{h}</span>
          </li>
        ))}
      </ul>
      <div className="overflow-auto rounded-lg border border-slate-200">
        <table className="w-full text-xs" data-testid="sip-queue-table">
          <thead className="bg-[#33456b] text-white">
            <tr>{COLS.map(([k, label]) => <th key={k} className="px-2.5 py-1.5 text-left font-semibold">{label}</th>)}</tr>
          </thead>
          <tbody>
            {queues.map((q, i) => (
              <tr key={q.queue} className={i % 2 ? "bg-slate-50" : "bg-white"} data-testid={`sip-queue-row-${i}`}>
                {COLS.map(([k]) => {
                  const v = k === "avg_wait" || k === "max_wait" ? secs(q[k]) : q[k];
                  const bad = (k === "no_agent_answer" || k === "timeout" || k === "abandoned") && q[k] > 0;
                  return (
                    <td key={k} className={`px-2.5 py-1.5 align-top ${bad ? "font-semibold text-rose-600" : "text-slate-600"}`}>
                      {v === null || v === undefined || v === "" ? "—" : v}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QueueInsight;
